<template>
    <div>
        <b-jumbotron>
            <h1>Servers</h1>
            <hr />
            <p>
                Get to know what you're connecting to.
            </p>
            <b-container>
                <b-card-group deck v-if="show">
                    <ServerCard
                        v-for="server in servers"
                        :key="server._id"
                        :id="server._id"
                    />
                </b-card-group>
            </b-container>
        </b-jumbotron>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import ServerCard from '@/components/user/servers/pagecard'

    export default {
        data() {
            return {
                show: false
            }
        },
        created() {
            this.$store.dispatch('user/servers/load').then(() => (this.show = true))
        },
        computed: mapState({
            servers: state => state.user.servers.servers
        }),
        components: {
            ServerCard
        }
    }
</script>